import { Box, Stepper, styled, Typography } from '@mui/material';

const ScrollableContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isExpanded' && prop !== 'fixedHeight',
})<{ isExpanded?: boolean; fixedHeight?: number | 'auto' }>(({ isExpanded, fixedHeight }) => {
  let heightStyles: { flex?: number; height: string; overflowY: 'auto' };
  if (fixedHeight === 'auto') {
    heightStyles = { flex: 1, height: '100%', overflowY: 'auto' };
  } else if (fixedHeight) {
    heightStyles = { height: `${fixedHeight}px`, overflowY: 'auto' };
  } else {
    heightStyles = { height: isExpanded ? '420px' : '270px', overflowY: 'auto' };
  }
  return {
    ...heightStyles,
    overflowX: 'hidden',
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(128,128,128,0.4)',
      borderRadius: '3px',
      '&:hover': {
        background: 'rgba(128,128,128,0.7)',
      },
    },
  };
});

const StyledStepper = styled(Stepper)({
  '& .MuiStep-root': {
    padding: 0,
    width: 'fit-content',
    '& .MuiStepLabel-root': {
      padding: 0,
    },
    '& .MuiStepLabel-labelContainer': {
      width: 'auto',
    },
  },
  '& .MuiStepConnector-line': {
    minHeight: 16,
  },
});

const UndoBubble = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(254, 243, 199, 0.1)' : '#fef3c7',
  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(252, 211, 77, 0.4)' : '#fcd34d'}`,
  borderRadius: '10px',
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '6px',
  paddingBottom: '6px',
  whiteSpace: 'nowrap',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: -9,
    top: '50%',
    transform: 'translateY(-50%)',
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    borderRight: `8px solid ${theme.palette.mode === 'dark' ? 'rgba(252, 211, 77, 0.4)' : '#fcd34d'}`,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    left: -7,
    top: '50%',
    transform: 'translateY(-50%)',
    borderTop: '7px solid transparent',
    borderBottom: '7px solid transparent',
    borderRight: `7px solid ${theme.palette.mode === 'dark' ? 'rgba(254, 243, 199, 0.1)' : '#fef3c7'}`,
  },
}));

const UndoBubbleText = styled(Typography)({
  fontSize: '0.8rem',
});

const UndoLink = styled('span')(({ theme }) => ({
  textDecoration: 'underline',
  cursor: 'pointer',
  fontWeight: 700,
  color: theme.palette.mode === 'dark' ? '#fcd34d' : '#92400e',
}));

export { ScrollableContainer, StyledStepper, UndoBubble, UndoBubbleText, UndoLink };
